export const RAILZ_DATE_FORMAT = 'yyyy-MM-dd';
